import dayjs from "dayjs"
const customParseFormat = require("dayjs/plugin/customParseFormat")
var isBetween = require("dayjs/plugin/isBetween")
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)

export type AgeValidationTypes = {
  valid: boolean
  value: {
    years: number
    months: number
    days: number
  }
  errorMsg: string
}

export type SpecialDateTypes = {
  valid: boolean
  value: string
  errorMsg: string
  formatValue: string
  triggerHelper: boolean
}

const pinCodeValidation = (value: string | number): { valid: boolean; value: string; errorMsg: string } => {
  let tempValue: string = value.toString()
  let errorMsg = ""
  tempValue = tempValue.replace(/\D/g, "")

  const pattern = /^(?!0{6})\d{6}$/

  // Check the length of the pincode
  if (tempValue.length < 6) {
    return {
      valid: false,
      value: tempValue,
      errorMsg: "Enter valid pincode"
    }
  } else {
    // Check if the pincode matches the pattern
    if (pattern.test(tempValue)) {
      return {
        valid: true,
        value: tempValue,
        errorMsg: errorMsg
      }
    } else {
      return {
        valid: false,
        value: tempValue,
        errorMsg: "Enter valid pincode"
      }
    }
  }
}

const mobileValidation = (value: string | number) => {
  var tempValue: string = value.toString()
  var errorMsg = ""
  // Remove Any Non Numerical Stuff
  tempValue = tempValue.replace(/\D/g, "").toString()

  // Starts with 6, 7, 8, 9 and Followed by 9 numbers.
  var pattern = /^[6-9][0-9]{9}$/

  if (pattern.test(tempValue)) {
    return {
      valid: true,
      value: tempValue,
      errorMsg: errorMsg
    }
  } else {
    return {
      valid: false,
      value: tempValue,
      errorMsg: "Enter 10 digit mobile number"
    }
  }
}

const ageValidation = (value: string, min: number, max: number, strict: boolean): AgeValidationTypes => {
  let regExp = /[a-zA-Z]/g
  let flag = regExp.test(value)
  let errorMsg = ""
  let isValid = false
  let years: number = 0
  let months: number = 0
  let days: number = 0

  const formattedDate = dayjs(value, "DD/MM/YYYY", true)
  years = dayjs().diff(formattedDate, "years")
  months = years === 0 && min === 0 ? dayjs().diff(formattedDate, "months") : 1
  days = months === 0 && min === 0 ? dayjs().diff(formattedDate, "days") : 1

  const today = dayjs()
  const ageInYears = today.diff(formattedDate, "year")
  const ageInMonths = today.diff(formattedDate, "month")
  const ageInDays = today.diff(formattedDate, "day")
  // console.log("ageIn year", ageInYears, "month", ageInMonths, "day", ageInDays)
  const yearEqualMax = today.month() === formattedDate.month() && today.date() === formattedDate.date()
  const yearEqualMin = ageInYears > min || (ageInYears === min && ageInMonths !== 0 && ageInDays !== 0)
  const yearGreaterMax = years > max
  const yearLessMin = years < min
  const ageBetween = `'s age should be between ${min} and ${max} years.`
  const validDOB = "Please Enter Valid date of birth"
  const valueKeyValue = {
    years: years,
    months: months,
    days: days
  }

  if (value !== "" && !flag && days > 0 && months >= 0) {
    if (years >= min && years <= max) {
      return {
        valid: true,
        value: valueKeyValue,
        errorMsg: errorMsg
      }
    }

    if (strict) {
      if (years === max) {
        return {
          valid: yearEqualMax ? true : false,
          value: valueKeyValue,
          errorMsg: yearEqualMax ? validDOB : ageBetween
        }
      } else if (years === min) {
        return {
          valid: yearEqualMin ? true : false,
          value: valueKeyValue,
          errorMsg: yearEqualMin ? validDOB : ageBetween
        }
      }
    }
  } else {
    years = -2
    errorMsg = ageBetween
    isValid = false
  }

  return {
    valid: false,
    value: valueKeyValue,
    errorMsg: yearGreaterMax || yearLessMin ? ageBetween : validDOB
  }
}

const emailValidation = (value: string) => {
  var regExp = /^([A-Za-z0-9_\-\.])+\@([a-zA-Z\-0-9]+\.)+([A-Za-z]{2,4})$/
  var errorMsg = ""
  if (regExp.test(value)) {
    return {
      valid: true,
      value,
      errorMsg: errorMsg
    }
  } else {
    return {
      valid: false,
      value,
      errorMsg: "Enter valid email id"
    }
  }
}

const specialDateValidation = (value: string, PT: number): SpecialDateTypes => {
  const FORMAT = "DD/MM/YYYY"
  const formatValue = dayjs(value, "DD | MM | YYYY", true)
  const isValid = dayjs(formatValue).isValid()
  const PolicyTerm = PT + 1
  const StartDateYearInc = PolicyTerm + 1
  const StartDateDayInc = 10
  const StartDate = dayjs().add(StartDateDayInc, "day").add(StartDateYearInc, "year")
  const EndDateDayDec = 1
  const EndDateYearInc = StartDateYearInc + 1
  const EndDate = dayjs().subtract(EndDateDayDec, "day").add(EndDateYearInc, "year")
  // @ts-ignore
  const isBetweenFlag = isValid ? dayjs(formatValue).isBetween(StartDate, EndDate, "day", "[]") : false
  const formatStartDate = dayjs(StartDate).format(FORMAT)
  const formatEndDate = dayjs(EndDate).format(FORMAT)
  const errorPrefix = isBetweenFlag || value === "" ? "You can select any" : "Please enter"
  const errorMsg = `${errorPrefix} date between <strong>${formatStartDate}</strong> and <strong>${formatEndDate}</strong>`
  return {
    valid: isBetweenFlag,
    value,
    errorMsg,
    formatValue: isValid && value ? formatValue.format(FORMAT).toString() : "",
    triggerHelper: value === ""
  }
}

const nameValidation = (value: string) => {
  var name = /^[A-Za-z ]+$/i
  var validName = /^(?!.*([A-Za-z])\1{2})([A-Za-z]*)([A-Za-z]+((\s){0,1}))*([A-Za-z])+$/
  var TWO_CONSEC_IDENTICAL_CHAR_VALIDATION = /(.)\1\1/
  var TWO_OR_MORE_SPACE = /\s\s+/
  var FIRST_LAST_SPACE = /(^\s+)|(\s+$)/
  var validNameSpace = /^[A-Za-z]([-']?[A-Za-z]+)*( [A-Za-z]([-']?[A-Za-z]+)*)+$/
  var errorMsg = ""

  // if (validNameSpace.test(value)) {
  //   var firstName = value.split(" ").slice(0, -1).join(" ")
  //   var lastName = value.split(" ").slice(-1).join(" ")

  //   if (TWO_CONSEC_IDENTICAL_CHAR_VALIDATION.test(firstName.toUpperCase()) || TWO_CONSEC_IDENTICAL_CHAR_VALIDATION.test(lastName.toUpperCase())) {
  //     errorMsg = "More Than 2 Consecutive Characters Not Allowed"
  //   } else if (!validName.test(firstName) || !validName.test(lastName)) {
  //     errorMsg = "Need Single Space Between First & Last Name"
  //   } else {
  //     errorMsg = ""
  //   }
  // } else {
  if (FIRST_LAST_SPACE.test(value)) {
    errorMsg = "Child's Name can't Start or End with Space"
  } else if (!name.test(value)) {
    errorMsg = "Please Enter Valid Child's Name"
  } else if (TWO_CONSEC_IDENTICAL_CHAR_VALIDATION.test(value.toUpperCase())) {
    errorMsg = "More Than 2 Consecutive Characters Not Allowed"
  } else if (TWO_OR_MORE_SPACE.test(value)) {
    errorMsg = "Only Single Space Allowed"
  }
  // }

  return {
    valid: errorMsg === "",
    value,
    errorMsg: errorMsg
  }
}

const getKeyByValueOfJson = (object: any, value: any) => {
  return Object.keys(object).find((key) => object[key] === value)
}

const getValueByKeyOfJson = (object: any, keyVal: any) => {
  for (var key in object) {
    if (key == keyVal) return object[key]
  }
  return ""
}

export { mobileValidation, ageValidation, emailValidation, specialDateValidation, nameValidation, getKeyByValueOfJson, getValueByKeyOfJson, pinCodeValidation }
